<template>
<span>
  <span class="badge badge-gray" v-if="this.status==1">Szkic</span>
  <span class="badge badge-alert" v-if="this.status==2">Przeznaczona do wysłania</span>
  <span class="badge badge-alert" v-if="this.status==3">W trakcie wysyłania</span>
  <span class="badge" v-if="this.status==4">Wysłana</span>
</span>
</template>
<script>
export default {
  props: ['status']
}
</script>


// WEBPACK FOOTER //
// MessageStatus.vue?74b8b30c